<div class="page">
  <app-page-header page-title="properties.suspendedList.pageTitle"></app-page-header>
  <div class="page-content">

    <mat-card class="custom-card">
      <mat-card-title>{{ 'properties.suspendedList.listTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExport()" class="d-none d-sm-inline-block"
                    *ngIf="loggedUserPermissions.includes('canExportProperties')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="dataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="name"
                matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="hasNotes">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs"></th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <button mat-icon-button (click)="onOpenNotes(element._id)" *ngIf="element.hasNotes">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-exclamation" color="primary"></mat-icon>
                    </button>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'properties.fields.name' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                     <a class="ml-2" routerLink="../{{element._id}}/home">
                      {{ element.name }}
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="nameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(nameFilter)"
                        class="reset-input-icon" *ngIf="nameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="taxCode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-sm">
                    {{ 'personalData.fields.taxCode' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.taxCode }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="taxCodeFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(taxCodeFilter)"
                        class="reset-input-icon" *ngIf="taxCodeFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="address">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'common.words.address' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.address.route }} {{ element.address.streetNumber }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="addressFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(addressFilter)"
                        class="reset-input-icon" *ngIf="addressFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="addressCity">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'common.words.city' | translate }}</th>
                  <td mat-cell *matCellDef="let element">{{ element.address.city }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="addressCityFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(addressCityFilter)"
                        class="reset-input-icon" *ngIf="addressCityFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="admin">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'properties.fields.admin' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    <a routerLink="../../companies/detail/{{ element.admin?.company?._id}}">
                      {{ element.admin?.company?.name }}
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="adminFilter" [matAutocomplete]="adminAuto">
                      <mat-autocomplete autoActiveFirstOption #adminAuto="matAutocomplete"
                        [displayWith]="displayAdminOrOwnerFn.bind(this)"
                        (onSelectionChange)="onAdminFilterSelected($event)">
                        <mat-option *ngIf="adminIsLoading" class="is-loading">
                          <mat-spinner diameter="50"></mat-spinner>
                        </mat-option>
                        <ng-container *ngIf="!adminIsLoading">
                          <mat-option *ngFor="let admin of availableAdmins" [value]="admin"
                            (onSelectionChange)="onAdminFilterSelected($event)">
                            <small>{{ admin.name }}</small>
                          </mat-option>
                        </ng-container>
                      </mat-autocomplete>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(adminFilter)"
                        class="reset-input-icon" *ngIf="adminFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-xs">
                    {{ 'properties.fields.status' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.status }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="statusFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="sag">{{ 'properties.statusTypes.sag' | translate }}</mat-option>
                        <mat-option value="mappConf">{{ 'properties.statusTypes.mappConf' | translate }}</mat-option>
                        <mat-option value="mappTermin">{{ 'properties.statusTypes.mappTermin' | translate }}</mat-option>
                        <mat-option value="inserimConf">{{ 'properties.statusTypes.inserimConf' | translate }}</mat-option>
                        <mat-option value="inserimConfParz">{{ 'properties.statusTypes.inserimConfParz' | translate }}</mat-option>
                        <mat-option value="inserimTermin">{{ 'properties.statusTypes.inserimTermin' | translate }}</mat-option>
                        <mat-option value="inserimTerminParz">{{ 'properties.statusTypes.inserimTerminParz' | translate }}</mat-option>
                        <mat-option value="mappCompl">{{ 'properties.statusTypes.mappCompl' | translate }}</mat-option>
                        <mat-option value="mappParz">{{ 'properties.statusTypes.mappParz' | translate }}</mat-option>
                        <mat-option value="ceased">{{ 'properties.statusTypes.ceased' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(statusFilter)"
                        class="reset-input-icon ml-n3" *ngIf="statusFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="subscriptionEndDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'properties.fields.subscriptionEndDateColumn' | translate }}</th>
                  <td mat-cell *matCellDef="let element">{{ element.subscription?.endDate | dateFormat }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="subscriptionEndDateFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilter(subscriptionEndDateFilter)" class="reset-input-icon"
                        *ngIf="subscriptionEndDateFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="totalDocsInserted">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-xs">
                    {{ 'properties.fields.totalDocs' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.totalDocsInserted ? element.totalDocsInserted : 0 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput type="number" [formControl]="totalDocsInsertedFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilter(totalDocsInsertedFilter)" class="reset-input-icon"
                        *ngIf="totalDocsInsertedFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="structureOpen">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'properties.fields.structureOpen' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-chip-list class="d-block py-2 px-1">
                      <mat-chip *ngIf="element.structureOpen && element.subscription?.key !== 'FREE' && element.subscription?.key !== 'FREEBASIC'" selected class="mat-chip-sm chip-green">
                        {{ 'common.words.openFemale' | translate }}
                      </mat-chip>
                      <mat-basic-chip *ngIf="element.structureOpen && (element.subscription?.key === 'FREE' || element.subscription?.key === 'FREEBASIC')" selected>
                        {{ 'properties.list.structureFree' | translate }}
                      </mat-basic-chip>
                      <mat-chip *ngIf="!element.structureOpen" selected class="mat-chip-sm chip-red">
                        {{ 'common.words.closedFemale' | translate }}
                      </mat-chip>
                    </mat-chip-list>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <a [routerLink]="'../my-property/' + element._id" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}"
                      *ngIf="this.loggedUserRoleType === 'temporary'">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-long-arrow-right"></mat-icon>
                    </a>
                    <button [matMenuTriggerFor]="listsMenu" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}"
                      *ngIf="this.loggedUserRoleType !== 'temporary'">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                    </button>
                    <mat-menu #listsMenu="matMenu" [hasBackdrop]="true">
                      <a mat-menu-item
                        routerLink="../{{element._id}}/home">{{ 'properties.list.goToData' | translate }}</a>
                      <a mat-menu-item routerLink="../{{element._id}}/mapping"
                        *ngIf="loggedUserPermissions.includes('canReadCondoStructuresList') && element.subscription.key !=='FREE' && element.subscription?.key !== 'FREEBASIC'">
                        {{ 'properties.list.goToMapping' | translate }}
                      </a>
                      <a mat-menu-item
                        routerLink="../{{element._id}}/documents">{{ 'properties.list.goToDocuments' | translate }}</a>
                      <a mat-menu-item *ngIf="loggedUserPermissions.includes('canSearchDocuments')"
                        routerLink="../{{element._id}}/search">{{ 'properties.list.searchDocuments' | translate }}</a>

                      <button mat-menu-item *ngIf="loggedUserPermissions.includes('canExportProperties')"
                        (click)="onExport('insertedDocs2025', element._id)">{{ 'properties.list.exportExpiredDocuments' | translate }}</button>
                      <button mat-menu-item *ngIf="loggedUserPermissions.includes('canExportProperties') && element.subscription.key !=='FREE' && element.subscription?.key !== 'FREEBASIC'"
                        (click)="onExport('missingDocs', element._id)">{{ 'properties.list.exportMissingDocuments' | translate }}</button>
                      <button mat-menu-item *ngIf="loggedUserRoleType === 'admin' || loggedUserRoleType === 'operator'"
                        (click)="onExportFile(element._id, element.name)">{{ 'properties.list.exportFile' | translate }}</button>
                    </mat-menu>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
              </table>
              <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->